module.exports = __webpack_public_path__ + "static/img/la_liga.66c48c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/old/la_liga.jpg
// module id = Y3Li
// module chunks = 1